<!-- program 主干 -->
<template>
  <div class="program-main">
    <div class="program-main-top">
      <div class="program-main-detail">
        <!-- 信息 -->
        <program-main-detail></program-main-detail>
      </div>
      <div class="program-main-menu">
        <!-- 导航 -->
        <menu-row :menuList="menuList"></menu-row>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
// components
import ProgramMainDetail from './components/program-main-detail'
import MenuRow from '_c/menu-row/menu-row'
import { mapState } from 'vuex'
export default {
  name: 'program-main',
  components: {
    ProgramMainDetail,
    MenuRow
  },
  data () {
    return {
      menuList: [
        {
          title: 'PS / Essay info',
          name: ['mentee-program-essay-info']
        },
        {
          title: 'PS / Essay edit',
          name: ['mentee-program-essay-edit']
        },
        {
          title: 'Mock interview',
          name: ['mentee-mock-interview', 'mentee-mock-zoom']
        }
      ]
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.showMenu()
  },
  methods: {
    showMenu () {
      if (this.userRole === 'EM') {
        this.menuList.pop()
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
